export default __webpack_public_path__ + "static/media/PlanetDecoration.70332cdf.png";